// extracted by mini-css-extract-plugin
export default {"container":"CheckboxWithTooltip_container__t4eNN","tooltip":"CheckboxWithTooltip_tooltip__E3KMo","icon":"CheckboxWithTooltip_icon__zaHJ8"};